<template>
  <div>
    <template v-if="info">
      <font-awesome-icon :icon="icon" /><h5 class="m-0 d-inline-block">{{info}}</h5>
    </template>
    <template v-else-if="mobileNumber">
      <font-awesome-icon :icon="icon" /><h5 class="m-0 d-inline-block "><a :href="'tel:'+mobileNumber">{{mobileNumber}}</a></h5>
    </template>
  </div>
</template>
<script lang="ts">
  import './headerIconVal.scss';

  import {defineComponent} from 'vue';
  import {useStore} from "vuex";

  export default defineComponent({
    props: {
      icon: String,
      info: {
        type: String,
        required: false
      },
      mobileNumber: {
        type: String,
        required: false
      },
    },

    setup() {
      const store = useStore();

      return {
        store,
      };
    },
  });
</script>